import ChevronLeft from 'components/Icons/ChevronLeft';
import { Button } from 'components/lib';
import React from 'react';

type Props = {
  onClick: () => void;
};

const BackButton: React.FC<Props> = ({ onClick }) => {
  return (
    <div className="row justify-start items-center">
      <Button
        variant="secondary"
        onClick={onClick}
        style={{ boxShadow: 'none', paddingLeft: '1rem', paddingRight: '1rem' }}
      >
        <ChevronLeft width="9px" height="16px" />
      </Button>
      <div className="hrem-1p5 wrem-1 ml2 bl-solid bl-width-1 b-light-grey-1" />
    </div>
  );
};

export default BackButton;
